import { useState } from "react";
import styles from "./ErrorMessage.module.css";
let unsetMessage = false
export function ErrorModal(props) {
  
  const closeModal = () => {
    if (
      props.messageType === "show" ||
      props.messageType === "standard" ||
      props.messageType === "empty-name"
    ) {
      props.updateChoosedOptions({
        registrationName: "",
        registrationNameFirst: "",
        registrationNameSecond: "",
      });
    }
    if (
      props.messageType === "show" ||
      props.messageType === "standard" ||
      props.messageType === "typeStandard" ||
      props.messageType === "typeShow" ||
      props.messageType === "empty-name"
    ) {
      props.addFocus();
    }
    if (props.messageType === "font" || props.messageType === "fontBothD" || props?.list?.font) {
      if (props.choosedOptions.typeOfTransport === "car") {
        props.updateChoosedOptions({
          fontStyle: "CharlesWright Bold",
          fontPrice: 0,
        });
      } else {
        props.updateChoosedOptions({
          fontStyle: "CharlesWright Motorcycle",
          fontPrice: 0,
        });
      }
    }
    if (
      props.messageType === "sizeBoth" ||
      props.messageType === "sizeBothD" ||
      props.messageType === "sizeRBoth" ||
      props?.list?.frsize
    ) {
      props.choosedOptions.typeOfTransport === "car"
        ? props.updateChoosedOptions({
            plateSizeFront: "Standard Car Oblong (20.5x4.4in)",
            plateSizeRear: "Standard Car Oblong (20.5x4.4in)",
            breakLine: "false",
          })
        : props.updateChoosedOptions({
            plateSizeFront: "Standard Motorcycle (9x7in)",
            plateSizeRear: "Standard Motorcycle (9x7in)",
            breakLine: "true",
          });
      if (
        props.choosedOptions.typeOfTransport === "motorbike" &&
        (props.choosedOptions.fontStyle === "laser3d webfont" ||
          props.choosedOptions.fontStyle === "Dome4D" ||
          props.choosedOptions.fontStyle === "Dome5D")
      ) {
        props.updateChoosedOptions({
          fontStyle: "CharlesWright Motorcycle",
          fontPrice: 0,
        });
      }
    }
    if (
      props.messageType === "sizeFront" ||
      props.messageType === "sizeFrontD" ||
      props?.list?.frsize
    ) {
      props.choosedOptions.typeOfTransport === "car"
        ? props.updateChoosedOptions({
            plateSizeFront: "Standard Car Oblong (20.5x4.4in)",
            breakLine: "false",
          })
        : props.updateChoosedOptions({
            plateSizeFront: "Standard Motorcycle (9x7in)",
            breakLine: "true",
          });
      if (
        props.choosedOptions.typeOfTransport === "motorbike" &&
        (props.choosedOptions.fontStyle === "laser3d webfont" ||
          props.choosedOptions.fontStyle === "Dome4D" ||
          props.choosedOptions.fontStyle === "Dome5D")
      ) {
        props.updateChoosedOptions({
          fontStyle: "CharlesWright Motorcycle",
          fontPrice: 0,
        });
      }
    }
    if (
      props.messageType === "sizeRear" ||
      props.messageType === "sizeRearD" ||
      props?.list?.rrsize
    ) {
      props.choosedOptions.typeOfTransport === "car"
        ? props.updateChoosedOptions({
            plateSizeRear: "Standard Car Oblong (20.5x4.4in)",
            breakLine: "false",
          })
        : props.updateChoosedOptions({
            plateSizeRear: "Standard Motorcycle (9x7in)",
            breakLine: "true",
          });
      if (
        props.choosedOptions.typeOfTransport === "motorbike" &&
        (props.choosedOptions.fontStyle === "laser3d webfont" ||
          props.choosedOptions.fontStyle === "Dome4D" ||
          props.choosedOptions.fontStyle === "Dome5D")
      ) {
        props.updateChoosedOptions({
          fontStyle: "CharlesWright Motorcycle",
          fontPrice: 0,
        });
      }
    }

    if (props.messageType === "material" || props?.list?.material) {
      if (
        props.choosedOptions.plateMaterial.includes("5D") ||
        props.choosedOptions.plateMaterial.includes("4D") ||
        props.choosedOptions.plateMaterial.includes("3D")
      ) {
        if (props.choosedOptions.typeOfTransport === "car") {
          props.updateChoosedOptions({
            fontStyle: "CharlesWright Bold",
            fontPrice: 0,
          });
        } else {
          props.updateChoosedOptions({
            fontStyle: "CharlesWright Motorcycle",
            fontPrice: 0,
          });
        }
      }
      props.updateChoosedOptions({
        plateMaterial: "Regular",
        materialPrice: 9.99,
      });
    }
    if (props.message === "3d-effect" || props.message === "3d-effect-limit") {
      if (props.choosedOptions.typeOfTransport === "car") {
        props.updateChoosedOptions({
          plateMaterial: "Regular",
          fontStyle: "CharlesWright Bold",
          fontPrice: 0,
        });
      } else {
        props.updateChoosedOptions({
          plateMaterial: "Regular",
          fontStyle: "CharlesWright Motorcycle",
          fontPrice: 0,
        });
      }
    }

    props.closeModal({
      isValid: true,
      message: "",
    });
  };
  const switchShowPlate = () => {
    props.closeModal({
      isValid: true,
      message: "",
    });
    props.updateChoosedOptions({
      categoryPlate: "show",
      sloganName: "",
      showBSAU: "false",
    });
  };

  const unsetPlate = () => {
    if (props.choosedOptions.categoryPlate.includes("show")) {
      props.updateChoosedOptions({
        categoryPlate: "standard",
        sloganName: "Great Plates, JE2 3RD",
        sloganColor: "black",
        sloganStyle: "Open Sans",
        sloganFont: "6px",
        fontColor: "black",
        hasCustomBadgeLeft: "false",
        hasCustomBadgeRight: "false",
        customBadgeLeft: "null",
        customBadgeRight: "null",
        customBadgeImageLeft: "null",
        customBadgeImageRight: "null",
        customBadgeTextLeft: "null",
        customBadgeTextRight: "null",
        customBadgeTextColorLeft: "null",
        customBadgeTextColorRight: "null",
        customBadgeRotationLeft: "false",
        customBadgeRotationRight: "false",
        badgeRight: "null",
        designRequired: "false",
        showBSAU: "true",
        fullHeightBadge: "false",
        badgeInsideBorder: "true"
      });
      let regValidLegal = /(^[A-Z]{2}[0-9]{2}\s?[A-Z]{3}$)/g.test(
        props.choosedOptions.registrationName
      );
      let length = props.choosedOptions.registrationName.length;
      if (length > 0 && length < 3) {
        regValidLegal = /^[A-Za-z\s]*$/.test(
          props.choosedOptions.registrationName
        );
      } else if (length >= 3 && length < 5) {
        regValidLegal = /^[0-9]*$/.test(
          props.choosedOptions.registrationName.slice(2, 4)
        );
      } else if (length >= 5 && length < 9) {
        regValidLegal = /^[A-Za-z\s]*$/.test(
          props.choosedOptions.registrationName.slice(4, 8)
        );
      }
      if (!regValidLegal) {
        props.updateChoosedOptions({
          registrationName: "",
          registrationNameFirst: "",
          registrationNameSecond: "",
        });
      } else {
        props.updateChoosedOptions({
          registrationName:
            length > 4
              ? props.choosedOptions.registrationName.slice(0, 4) +
                " " +
                props.choosedOptions.registrationName.slice(4).trim()
              : props.choosedOptions.registrationName.slice(0, 4),
          registrationNameFirst: props.choosedOptions.registrationName.slice(
            0,
            4
          ),
          registrationNameSecond: props.choosedOptions.registrationName
            .slice(4)
            .trim(),
        });
      }
    }
    if (props.choosedOptions.categoryPlate.includes("standard")) {
      props.updateChoosedOptions({
        categoryPlate: "show",
        sloganName: "",
        showBSAU: "false",
      });
    }
    closeModal();
  };
  const anchorLink = () => {
    document.querySelector("#check176").checked = true;
    closeModal();
    document
      .querySelectorAll(".tab-with-accordions__btn")
      .forEach((item, index) => {
        if (index !== 0) {
          item.classList.remove("tab-with-accordions__btn--active");
        } else {
          item.classList.add("tab-with-accordions__btn--active");
        }
      });
    document
      .querySelectorAll(".tab-with-accordions__content")
      .forEach((item, index) => {
        if (index !== 0) {
          item.classList.remove("tab-with-accordions__content--active");
        } else {
          item.classList.add("tab-with-accordions__content--active");
        }
      });
  };

  

  if(props.messageType === "list-change" && unsetMessage) {
    unsetPlate()
  }
  
  return (
    <div
      className={styles["modal-error"] + " flex items-center justify-center"}
    >
      <>
        {props.messageType === "empty-name" && (
          <>
            <div className={styles["modal-error__fader"]} onClick={closeModal}>
              {" "}
            </div>
            <div className={styles["modal-error__wrapper"]}>
              <div
                className={styles["modal-error__close"]}
                onClick={closeModal}
              ></div>
              <h6>Attention needed</h6>
              <div className={styles["modal-error__message"]}>
                Please enter your registration in the specified field to
                proceed.
              </div>
              <div
                className={
                  styles["modal-error__buttons"] + " flex justify-end flex-wrap"
                }
              >
                <div
                  className={styles["modal-error__btn"] + " btn"}
                  onClick={closeModal}
                >
                  Ok
                </div>
              </div>
            </div>
          </>
        )}
        {props.messageType === "standard" && (
          <>
            <div className={styles["modal-error__fader"]} onClick={closeModal}>
              {" "}
            </div>
            <div className={styles["modal-error__wrapper"]}>
              <div
                className={styles["modal-error__close"]}
                onClick={closeModal}
              ></div>
              <h6>Attention needed</h6>
              <div className={styles["modal-error__message"]}>
                Registration text is not British standard compliant. The format of a compliant plate is 2 letters, 2 numbers, a space and finally 3 letters or 1 letter, 2 numbers, a space and finally 3 letters, for example 'AB12 CDE' or 'A12 CDE'. Please select the ‘switch to show plates’ button below should you wish to allow other formats.              </div>
              <div
                className={
                  styles["modal-error__buttons"] + " flex justify-end flex-wrap"
                }
              >
                <a
                  onClick={anchorLink}
                  href="#tab"
                  className={styles["modal-error__btn"] + " btn"}
                >
                  What is a Show Plate?
                </a>
                <div
                  className={styles["modal-error__btn"] + " btn"}
                  onClick={switchShowPlate}
                >
                  Switch to show plates
                </div>
                <div
                  className={styles["modal-error__btn"] + " btn"}
                  onClick={closeModal}
                >
                  Legal style plate
                </div>
              </div>
            </div>
          </>
        )}
        {props.messageType === "3d-effect" && (
          <>
            <div className={styles["modal-error__fader"]} onClick={closeModal}>
              {" "}
            </div>
            <div className={styles["modal-error__wrapper"]}>
              <div
                className={styles["modal-error__close"]}
                onClick={closeModal}
              ></div>
              <h6>Attention needed</h6>
              <div className={styles["modal-error__message"]}>
                3D Domed, 4D Laser Cut and 5D Laser Cut are only available on
                default registration sizes.
              </div>
              <div
                className={
                  styles["modal-error__buttons"] + " flex justify-end flex-wrap"
                }
              >
                <div
                  className={styles["modal-error__btn"] + " btn"}
                  onClick={closeModal}
                >
                  Ok
                </div>
              </div>
            </div>
          </>
        )}
        {props.messageType === "3d-effect-limit" && (
          <>
            <div className={styles["modal-error__fader"]} onClick={closeModal}>
              {" "}
            </div>
            <div className={styles["modal-error__wrapper"]}>
              <div
                className={styles["modal-error__close"]}
                onClick={closeModal}
              ></div>
              <h6>Attention needed</h6>
              <div className={styles["modal-error__message"]}>
                Registration text exceeds the available space for this font.
                (too many characters)
              </div>
              <div
                className={
                  styles["modal-error__buttons"] + " flex justify-end flex-wrap"
                }
              >
                <div
                  className={styles["modal-error__btn"] + " btn"}
                  onClick={closeModal}
                >
                  Ok
                </div>
              </div>
            </div>
          </>
        )}
        {props.messageType === "pressed-metal" && (
          <>
            <div className={styles["modal-error__fader"]} onClick={closeModal}>
              {" "}
            </div>
            <div className={styles["modal-error__wrapper"]}>
              <div
                className={styles["modal-error__close"]}
                onClick={closeModal}
              ></div>
              <h6>Attention needed</h6>
              <div className={styles["modal-error__message"]}>
                Due to the manual pressing process, our metal plates have a
                fixed character limit and cannot accommodate additional
                characters.
              </div>
              <div
                className={
                  styles["modal-error__buttons"] + " flex justify-end flex-wrap"
                }
              >
                <div
                  className={styles["modal-error__btn"] + " btn"}
                  onClick={closeModal}
                >
                  Ok
                </div>
              </div>
            </div>
          </>
        )}
        {props.messageType === "show" && (
          <>
            <div className={styles["modal-error__fader"]} onClick={closeModal}>
              {" "}
            </div>
            <div className={styles["modal-error__wrapper"]}>
              <div
                className={styles["modal-error__close"]}
                onClick={closeModal}
              ></div>
              <h6>Attention needed</h6>
              <div className={styles["modal-error__message"]}>
                Be aware that not all special characters (e.g. &,!,',@) are not
                recognised for all fonts. Ensure to check the image for what the
                final print will show.
              </div>
              <div
                className={styles["modal-error__buttons"] + " flex justify-end"}
              >
                <div
                  className={styles["modal-error__btn"] + " btn"}
                  onClick={closeModal}
                >
                  Ok
                </div>
              </div>
            </div>
          </>
        )}
        {props.messageType === "bsau" && (
          <>
            <div className={styles["modal-error__fader"]} onClick={closeModal}>
              {" "}
            </div>
            <div className={styles["modal-error__wrapper"]}>
              <div
                className={styles["modal-error__close"]}
                onClick={closeModal}
              ></div>
              <h6>Attention needed</h6>
              <div className={styles["modal-error__message"]}>
                A plate cannot display both BSAU and a right-hand badge at the
                same time.
              </div>
              <div
                className={styles["modal-error__buttons"] + " flex justify-end"}
              >
                <div
                  className={styles["modal-error__btn"] + " btn"}
                  onClick={closeModal}
                >
                  Ok
                </div>
              </div>
            </div>
          </>
        )}
        {props.messageType === "typeStandard" && (
          <>
            <div className={styles["modal-error__fader"]} onClick={closeModal}>
              {" "}
            </div>
            <div className={styles["modal-error__wrapper"]}>
              <div
                className={styles["modal-error__close"]}
                onClick={closeModal}
              ></div>
              <h6>Attention needed</h6>
              <div className={styles["modal-error__message"]}>
              Registration text is not British standard compliant. The format of a compliant plate is 2 letters, 2 numbers, a space and finally 3 letters or 1 letter, 2 numbers, a space and finally 3 letters, for example 'AB12 CDE' or 'A12 CDE'. Please select the ‘switch to show plates’ button below should you wish to allow other formats.        
              </div>
              <div
                className={
                  styles["modal-error__buttons"] + " flex justify-end flex-wrap"
                }
              >
                <a
                  onClick={anchorLink}
                  href="#tab"
                  className={styles["modal-error__btn"] + " btn"}
                >
                  What is a Show Plate?
                </a>
                <div
                  className={styles["modal-error__btn"] + " btn"}
                  onClick={switchShowPlate}
                >
                  Switch to show plates
                </div>
                <div
                  className={styles["modal-error__btn"] + " btn"}
                  onClick={closeModal}
                >
                  Ok
                </div>
              </div>
            </div>
          </>
        )}
        {props.messageType === "typeShow" && (
          <>
            <div className={styles["modal-error__fader"]} onClick={closeModal}>
              {" "}
            </div>
            <div className={styles["modal-error__wrapper"]}>
              <div
                className={styles["modal-error__close"]}
                onClick={closeModal}
              ></div>
              <h6>Attention needed</h6>
              <div className={styles["modal-error__message"]}>
                Be aware that not all special characters (e.g. &,!,',@) are not
                recognised for all fonts. Ensure to check the image for what the
                final print will show.
              </div>
              <div
                className={styles["modal-error__buttons"] + " flex justify-end"}
              >
                <div
                  className={styles["modal-error__btn"] + " btn"}
                  onClick={closeModal}
                >
                  Ok
                </div>
              </div>
            </div>
          </>
        )}
        {props.messageType === "sizeRear" && (
          <>
            <div className={styles["modal-error__fader"]} onClick={closeModal}>
              {" "}
            </div>
            <div className={styles["modal-error__wrapper"]}>
              <div
                className={styles["modal-error__close"]}
                onClick={closeModal}
              ></div>
              <h6>Attention needed</h6>
              <div className={styles["modal-error__message"]}>
                The plate size {props.choosedOptions.plateSizeRear} is not
                supported with the options previously selected
              </div>
              <div
                className={styles["modal-error__buttons"] + " flex justify-end"}
              >
                <div
                  className={styles["modal-error__btn"] + " btn"}
                  onClick={closeModal()}
                >
                  Ok
                </div>
              </div>
            </div>
          </>
        )}
        {props.messageType === "sizeFront" && (
          <>
            <div className={styles["modal-error__fader"]} onClick={closeModal}>
              {" "}
            </div>
            <div className={styles["modal-error__wrapper"]}>
              <div
                className={styles["modal-error__close"]}
                onClick={closeModal}
              ></div>
              <h6>Attention needed</h6>
              <div className={styles["modal-error__message"]}>
                The plate size {props.choosedOptions.plateSizeFront} is not
                supported with the options previously selected
              </div>
              <div
                className={styles["modal-error__buttons"] + " flex justify-end"}
              >
                <div
                  className={styles["modal-error__btn"] + " btn"}
                  onClick={closeModal()}
                >
                  Ok
                </div>
              </div>
            </div>
          </>
        )}
        {props.messageType === "sizeBoth" || props.messageType === "sizeRBoth" && (
          <>
            <div className={styles["modal-error__fader"]} onClick={closeModal}>
              {" "}
            </div>
            <div className={styles["modal-error__wrapper"]}>
              <div
                className={styles["modal-error__close"]}
                onClick={closeModal}
              ></div>
              <h6>Attention needed</h6>
              <div className={styles["modal-error__message"]}>
                The plate sizes {props.choosedOptions.plateSizeFront} and{" "}
                {props.choosedOptions.plateSizeRear} are not supported with the
                options previously selected
              </div>
              <div
                className={styles["modal-error__buttons"] + " flex justify-end"}
              >
                <div
                  className={styles["modal-error__btn"] + " btn"}
                  onClick={closeModal()}
                >
                  Ok
                </div>
              </div>
            </div>
          </>
        )}
        {(props.messageType === "material" ||
          props.messageType === "CustomMaterial") && (
          <>
            <div className={styles["modal-error__fader"]} onClick={closeModal}>
              {" "}
            </div>
            <div className={styles["modal-error__wrapper"]}>
              <div
                className={styles["modal-error__close"]}
                onClick={closeModal}
              ></div>
              <h6>Attention needed</h6>
              {props.choosedOptions.plateMaterial.includes("5D") ||
              props.choosedOptions.plateMaterial.includes("4D") ||
              props.choosedOptions.plateMaterial.includes("3D") ? (
                <div className={styles["modal-error__message"]}>
                  The plate font style 3D Domed, 5D Raised and 4D Laser Cut are
                  not supported with the options previously selected
                </div>
              ) : (
                <div className={styles["modal-error__message"]}>
                  The plate material {props.choosedOptions.plateMaterial} is not
                  supported with the options previously selected
                </div>
              )}
              <div
                className={styles["modal-error__buttons"] + " flex justify-end"}
              >
                <div
                  className={styles["modal-error__btn"] + " btn"}
                  onClick={closeModal()}
                >
                  Ok
                </div>
              </div>
            </div>
          </>
        )}
        {
          props.messageType === "fontBothD" && (
          <>
            <div className={styles["modal-error__fader"]} onClick={closeModal}>
              {" "}
            </div>
            <div className={styles["modal-error__wrapper"]}>
              <div
                className={styles["modal-error__close"]}
                onClick={closeModal}
              ></div>
              <h6>Attention needed</h6>
              <div className={styles["modal-error__message"]}>
                3D Domed, 5D Raised and 4D Raised fonts are not available
                for this plate material.
              </div>
              <div
                className={styles["modal-error__buttons"] + " flex justify-end"}
              >
                <div
                  className={styles["modal-error__btn"] + " btn"}
                  onClick={closeModal}
                >
                  Ok
                </div>
              </div>
            </div>
          </>
        )}
        {(props.messageType === "sizeRearD" ||
          props.messageType === "sizeFrontD" ||
          props.messageType === "sizeBothD") && (
          <>
            <div className={styles["modal-error__fader"]} onClick={closeModal}>
              {" "}
            </div>
            <div className={styles["modal-error__wrapper"]}>
              <div
                className={styles["modal-error__close"]}
                onClick={closeModal}
              ></div>
              <h6>Attention needed</h6>
              <div className={styles["modal-error__message"]}>
                3D Domed, 5D Raised and 4D Raised fonts are not available
                for this plate size.
              </div>
              <div
                className={styles["modal-error__buttons"] + " flex justify-end"}
              >
                <div
                  className={styles["modal-error__btn"] + " btn"}
                  onClick={closeModal}
                >
                  Ok
                </div>
              </div>
            </div>
          </>
        )}
        {(props.messageType === "font" ||
          props.messageType === "CustomFont") && (
          <>
            <div className={styles["modal-error__fader"]} onClick={closeModal}>
              {" "}
            </div>
            <div className={styles["modal-error__wrapper"]}>
              <div
                className={styles["modal-error__close"]}
                onClick={closeModal}
              ></div>
              <h6>Attention needed</h6>
              <div className={styles["modal-error__message"]}>
                The plate font style{" "}
                {props.choosedOptions.fontStyle === "laser3d webfont" ||
                props.choosedOptions.fontStyle === "Dome4D" ||
                props.choosedOptions.fontStyle === "Dome5D"
                  ? "3D Domed, 5D Raised and 4D Laser Cut are"
                  : props.choosedOptions.fontStyle + " is"}{" "}
                not supported with the options previously selected
              </div>
              <div
                className={styles["modal-error__buttons"] + " flex justify-end"}
              >
                <div
                  className={styles["modal-error__btn"] + " btn"}
                  onClick={closeModal}
                >
                  Ok
                </div>
              </div>
            </div>
          </>
        )}
        {props.messageType === "list-change" && !unsetMessage && (
          <>
            <div className={styles["modal-error__fader"]} onClick={closeModal}>
              {" "}
            </div>
            <div className={styles["modal-error__wrapper"]}>
              <div
                className={styles["modal-error__close"]}
                onClick={closeModal}
              ></div>
              <h6>Attention needed</h6>
              <div className={styles["modal-error__message"]}>
                The following elements will be removed if you switch to a{" "}
                {props.choosedOptions.categoryPlate.includes("standard")
                  ? "Show Plate"
                  : "Road Compliant Plate"}
                :
              </div>
              <ul>
                {Object.keys(props.list).map((item, index) => {
                  return <li key={index}>{props.list[item]}</li>;
                })}
              </ul>
              <div
                className={styles["modal-error__buttons"] + " flex justify-end flex-wrap"}
              >
                <div
                  className={styles["modal-error__btn"] + " btn"}
                  onClick={() =>
                    props.closeModal({ isValid: true, message: "" })
                  }
                >
                  Cancel
                </div>
                <div
                  className={styles["modal-error__btn"] + " btn"}
                  onClick={() => {
                    unsetMessage = true
                    unsetPlate()
                  }}
                >
                  Don't show this message again
                </div>
                <div
                  className={styles["modal-error__btn"] + " btn"}
                  onClick={unsetPlate}
                >
                  Continue
                </div>
              </div>
            </div>
          </>
        )}
      </>
    </div>
  );
}
